import { axios } from '@Root/API'

export const get = roleId => {
	return axios.get(`roles/${roleId}/id`)
}
